/**
 * @fileoverview gRPC-Web generated client stub for somewear.api.v1
 * @enhanceable
 * @public
 */
// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v5.29.0
// source: api/workspace.proto
/* eslint-disable */
// @ts-nocheck
import * as grpcWeb from 'grpc-web';
import * as style_proto_pb from '../style_proto_pb'; // proto import: "style_proto.proto"
import * as user_proto_pb from '../user_proto_pb'; // proto import: "user_proto.proto"
import * as api_workspace_pb from '../api/workspace_pb'; // proto import: "api/workspace.proto"
import * as api_device_pb from '../api/device_pb'; // proto import: "api/device.proto"
import * as api_user_pb from '../api/user_pb'; // proto import: "api/user.proto"
export class WorkspaceClient {
    client_;
    hostname_;
    credentials_;
    options_;
    constructor(hostname, credentials, options) {
        if (!options)
            options = {};
        if (!credentials)
            credentials = {};
        options['format'] = 'text';
        this.client_ = new grpcWeb.GrpcWebClientBase(options);
        this.hostname_ = hostname.replace(/\/+$/, '');
        this.credentials_ = credentials;
        this.options_ = options;
    }
    methodDescriptorInviteMembers = new grpcWeb.MethodDescriptor('/somewear.api.v1.Workspace/InviteMembers', grpcWeb.MethodType.UNARY, api_workspace_pb.InviteMembersRequest, api_workspace_pb.InviteMembersResponse, (request) => {
        return request.serializeBinary();
    }, api_workspace_pb.InviteMembersResponse.deserializeBinary);
    inviteMembers(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Workspace/InviteMembers', request, metadata || {}, this.methodDescriptorInviteMembers, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Workspace/InviteMembers', request, metadata || {}, this.methodDescriptorInviteMembers);
    }
    methodDescriptorArchiveMembers = new grpcWeb.MethodDescriptor('/somewear.api.v1.Workspace/ArchiveMembers', grpcWeb.MethodType.UNARY, api_workspace_pb.ArchiveMembersRequest, api_workspace_pb.ArchiveMembersResponse, (request) => {
        return request.serializeBinary();
    }, api_workspace_pb.ArchiveMembersResponse.deserializeBinary);
    archiveMembers(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Workspace/ArchiveMembers', request, metadata || {}, this.methodDescriptorArchiveMembers, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Workspace/ArchiveMembers', request, metadata || {}, this.methodDescriptorArchiveMembers);
    }
    methodDescriptorRemoveMembers = new grpcWeb.MethodDescriptor('/somewear.api.v1.Workspace/RemoveMembers', grpcWeb.MethodType.UNARY, api_workspace_pb.RemoveMembersRequest, api_workspace_pb.RemoveMembersResponse, (request) => {
        return request.serializeBinary();
    }, api_workspace_pb.RemoveMembersResponse.deserializeBinary);
    removeMembers(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Workspace/RemoveMembers', request, metadata || {}, this.methodDescriptorRemoveMembers, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Workspace/RemoveMembers', request, metadata || {}, this.methodDescriptorRemoveMembers);
    }
    methodDescriptorCreateWorkspaceKey = new grpcWeb.MethodDescriptor('/somewear.api.v1.Workspace/CreateWorkspaceKey', grpcWeb.MethodType.UNARY, api_workspace_pb.CreateWorkspaceKeyApiRequest, api_workspace_pb.CreateWorkspaceKeyApiResponse, (request) => {
        return request.serializeBinary();
    }, api_workspace_pb.CreateWorkspaceKeyApiResponse.deserializeBinary);
    createWorkspaceKey(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Workspace/CreateWorkspaceKey', request, metadata || {}, this.methodDescriptorCreateWorkspaceKey, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Workspace/CreateWorkspaceKey', request, metadata || {}, this.methodDescriptorCreateWorkspaceKey);
    }
    methodDescriptorCreateResourceAccount = new grpcWeb.MethodDescriptor('/somewear.api.v1.Workspace/CreateResourceAccount', grpcWeb.MethodType.UNARY, api_workspace_pb.CreateResourceAccountRequest, api_workspace_pb.CreateResourceAccountResponse, (request) => {
        return request.serializeBinary();
    }, api_workspace_pb.CreateResourceAccountResponse.deserializeBinary);
    createResourceAccount(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Workspace/CreateResourceAccount', request, metadata || {}, this.methodDescriptorCreateResourceAccount, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Workspace/CreateResourceAccount', request, metadata || {}, this.methodDescriptorCreateResourceAccount);
    }
    methodDescriptorUpdateWorkspaceRole = new grpcWeb.MethodDescriptor('/somewear.api.v1.Workspace/UpdateWorkspaceRole', grpcWeb.MethodType.UNARY, api_workspace_pb.UpdateWorkspaceRoleRequest, api_workspace_pb.UpdateWorkspaceRoleResponse, (request) => {
        return request.serializeBinary();
    }, api_workspace_pb.UpdateWorkspaceRoleResponse.deserializeBinary);
    updateWorkspaceRole(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Workspace/UpdateWorkspaceRole', request, metadata || {}, this.methodDescriptorUpdateWorkspaceRole, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Workspace/UpdateWorkspaceRole', request, metadata || {}, this.methodDescriptorUpdateWorkspaceRole);
    }
    methodDescriptorArchiveWorkspace = new grpcWeb.MethodDescriptor('/somewear.api.v1.Workspace/ArchiveWorkspace', grpcWeb.MethodType.UNARY, api_workspace_pb.ArchiveWorkspaceRequest, api_workspace_pb.UpdateWorkspaceAccessResponse, (request) => {
        return request.serializeBinary();
    }, api_workspace_pb.UpdateWorkspaceAccessResponse.deserializeBinary);
    archiveWorkspace(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Workspace/ArchiveWorkspace', request, metadata || {}, this.methodDescriptorArchiveWorkspace, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Workspace/ArchiveWorkspace', request, metadata || {}, this.methodDescriptorArchiveWorkspace);
    }
    methodDescriptorDeleteWorkspace = new grpcWeb.MethodDescriptor('/somewear.api.v1.Workspace/DeleteWorkspace', grpcWeb.MethodType.UNARY, api_workspace_pb.DeleteWorkspaceRequest, api_workspace_pb.UpdateWorkspaceAccessResponse, (request) => {
        return request.serializeBinary();
    }, api_workspace_pb.UpdateWorkspaceAccessResponse.deserializeBinary);
    deleteWorkspace(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Workspace/DeleteWorkspace', request, metadata || {}, this.methodDescriptorDeleteWorkspace, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Workspace/DeleteWorkspace', request, metadata || {}, this.methodDescriptorDeleteWorkspace);
    }
    methodDescriptorLeaveWorkspace = new grpcWeb.MethodDescriptor('/somewear.api.v1.Workspace/LeaveWorkspace', grpcWeb.MethodType.UNARY, api_workspace_pb.LeaveWorkspaceRequest, api_workspace_pb.ArchiveMembersResponse, (request) => {
        return request.serializeBinary();
    }, api_workspace_pb.ArchiveMembersResponse.deserializeBinary);
    leaveWorkspace(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Workspace/LeaveWorkspace', request, metadata || {}, this.methodDescriptorLeaveWorkspace, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Workspace/LeaveWorkspace', request, metadata || {}, this.methodDescriptorLeaveWorkspace);
    }
    methodDescriptorIssueWorkspaceInviteToken = new grpcWeb.MethodDescriptor('/somewear.api.v1.Workspace/IssueWorkspaceInviteToken', grpcWeb.MethodType.UNARY, api_workspace_pb.IssueWorkspaceInviteTokenRequest, api_workspace_pb.IssueWorkspaceInviteTokenResponse, (request) => {
        return request.serializeBinary();
    }, api_workspace_pb.IssueWorkspaceInviteTokenResponse.deserializeBinary);
    issueWorkspaceInviteToken(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Workspace/IssueWorkspaceInviteToken', request, metadata || {}, this.methodDescriptorIssueWorkspaceInviteToken, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Workspace/IssueWorkspaceInviteToken', request, metadata || {}, this.methodDescriptorIssueWorkspaceInviteToken);
    }
    methodDescriptorJoinWorkspaceByInvite = new grpcWeb.MethodDescriptor('/somewear.api.v1.Workspace/JoinWorkspaceByInvite', grpcWeb.MethodType.UNARY, api_workspace_pb.JoinWorkspaceByInviteRequest, api_workspace_pb.JoinWorkspaceByInviteResponse, (request) => {
        return request.serializeBinary();
    }, api_workspace_pb.JoinWorkspaceByInviteResponse.deserializeBinary);
    joinWorkspaceByInvite(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Workspace/JoinWorkspaceByInvite', request, metadata || {}, this.methodDescriptorJoinWorkspaceByInvite, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Workspace/JoinWorkspaceByInvite', request, metadata || {}, this.methodDescriptorJoinWorkspaceByInvite);
    }
    methodDescriptorToggleWorkspaceIntegration = new grpcWeb.MethodDescriptor('/somewear.api.v1.Workspace/ToggleWorkspaceIntegration', grpcWeb.MethodType.UNARY, api_workspace_pb.ToggleWorkspaceIntegrationRequest, user_proto_pb.UserResponse, (request) => {
        return request.serializeBinary();
    }, user_proto_pb.UserResponse.deserializeBinary);
    toggleWorkspaceIntegration(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Workspace/ToggleWorkspaceIntegration', request, metadata || {}, this.methodDescriptorToggleWorkspaceIntegration, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Workspace/ToggleWorkspaceIntegration', request, metadata || {}, this.methodDescriptorToggleWorkspaceIntegration);
    }
    methodDescriptorGetWorkspaces = new grpcWeb.MethodDescriptor('/somewear.api.v1.Workspace/GetWorkspaces', grpcWeb.MethodType.UNARY, api_user_pb.GetWorkspacesRequest, user_proto_pb.WorkspaceResponseList, (request) => {
        return request.serializeBinary();
    }, user_proto_pb.WorkspaceResponseList.deserializeBinary);
    getWorkspaces(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Workspace/GetWorkspaces', request, metadata || {}, this.methodDescriptorGetWorkspaces, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Workspace/GetWorkspaces', request, metadata || {}, this.methodDescriptorGetWorkspaces);
    }
    methodDescriptorTransferDevices = new grpcWeb.MethodDescriptor('/somewear.api.v1.Workspace/TransferDevices', grpcWeb.MethodType.UNARY, api_workspace_pb.TransferDevicesRequest, api_workspace_pb.TransferDevicesResponse, (request) => {
        return request.serializeBinary();
    }, api_workspace_pb.TransferDevicesResponse.deserializeBinary);
    transferDevices(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Workspace/TransferDevices', request, metadata || {}, this.methodDescriptorTransferDevices, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Workspace/TransferDevices', request, metadata || {}, this.methodDescriptorTransferDevices);
    }
    methodDescriptorAssignDevice = new grpcWeb.MethodDescriptor('/somewear.api.v1.Workspace/AssignDevice', grpcWeb.MethodType.UNARY, api_device_pb.AssignDeviceRequest, api_device_pb.AssignDeviceResponse, (request) => {
        return request.serializeBinary();
    }, api_device_pb.AssignDeviceResponse.deserializeBinary);
    assignDevice(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Workspace/AssignDevice', request, metadata || {}, this.methodDescriptorAssignDevice, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Workspace/AssignDevice', request, metadata || {}, this.methodDescriptorAssignDevice);
    }
    methodDescriptorUnassignDevice = new grpcWeb.MethodDescriptor('/somewear.api.v1.Workspace/UnassignDevice', grpcWeb.MethodType.UNARY, api_device_pb.UnassignDeviceRequest, api_device_pb.UnassignDeviceResponse, (request) => {
        return request.serializeBinary();
    }, api_device_pb.UnassignDeviceResponse.deserializeBinary);
    unassignDevice(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Workspace/UnassignDevice', request, metadata || {}, this.methodDescriptorUnassignDevice, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Workspace/UnassignDevice', request, metadata || {}, this.methodDescriptorUnassignDevice);
    }
    methodDescriptorUpdateStyle = new grpcWeb.MethodDescriptor('/somewear.api.v1.Workspace/UpdateStyle', grpcWeb.MethodType.UNARY, style_proto_pb.UpdateStyleSettingsRequest, user_proto_pb.WorkspaceResponse, (request) => {
        return request.serializeBinary();
    }, user_proto_pb.WorkspaceResponse.deserializeBinary);
    updateStyle(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Workspace/UpdateStyle', request, metadata || {}, this.methodDescriptorUpdateStyle, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Workspace/UpdateStyle', request, metadata || {}, this.methodDescriptorUpdateStyle);
    }
    methodDescriptorGetDefaultSettings = new grpcWeb.MethodDescriptor('/somewear.api.v1.Workspace/GetDefaultSettings', grpcWeb.MethodType.UNARY, api_workspace_pb.GetDefaultSettingsRequest, api_workspace_pb.GetDefaultSettingsResponse, (request) => {
        return request.serializeBinary();
    }, api_workspace_pb.GetDefaultSettingsResponse.deserializeBinary);
    getDefaultSettings(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Workspace/GetDefaultSettings', request, metadata || {}, this.methodDescriptorGetDefaultSettings, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Workspace/GetDefaultSettings', request, metadata || {}, this.methodDescriptorGetDefaultSettings);
    }
    methodDescriptorUpdateDefaultSettings = new grpcWeb.MethodDescriptor('/somewear.api.v1.Workspace/UpdateDefaultSettings', grpcWeb.MethodType.UNARY, api_workspace_pb.UpdateDefaultSettingsRequest, api_workspace_pb.GetDefaultSettingsResponse, (request) => {
        return request.serializeBinary();
    }, api_workspace_pb.GetDefaultSettingsResponse.deserializeBinary);
    updateDefaultSettings(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Workspace/UpdateDefaultSettings', request, metadata || {}, this.methodDescriptorUpdateDefaultSettings, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Workspace/UpdateDefaultSettings', request, metadata || {}, this.methodDescriptorUpdateDefaultSettings);
    }
    methodDescriptorApplyDefaultSettings = new grpcWeb.MethodDescriptor('/somewear.api.v1.Workspace/ApplyDefaultSettings', grpcWeb.MethodType.UNARY, api_workspace_pb.ApplyDefaultSettingsRequest, api_workspace_pb.GetDefaultSettingsResponse, (request) => {
        return request.serializeBinary();
    }, api_workspace_pb.GetDefaultSettingsResponse.deserializeBinary);
    applyDefaultSettings(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Workspace/ApplyDefaultSettings', request, metadata || {}, this.methodDescriptorApplyDefaultSettings, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Workspace/ApplyDefaultSettings', request, metadata || {}, this.methodDescriptorApplyDefaultSettings);
    }
}
//# sourceMappingURL=WorkspaceServiceClientPb.js.map